import { loadCurrentUserNetworks } from '@ms/yammer-data/dist/domains/currentUserNetworks/actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

type UseLoadCurrentUserNetworks = () => void;
export const useLoadCurrentUserNetworks: UseLoadCurrentUserNetworks = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadCurrentUserNetworks());
    // oxlint-disable-next-line react/exhaustive-deps
  }, []);
};
